import { User } from "../../../auth/types";
import { httpWebApi } from "../../../../core/http/httpThunks";
import { getParamsDateString } from "../../../../core/util/functions";
import { WeeklyTradingReportFilter } from "../types";

export const getWeeklyDateReport = (
  user: User,
  filter: WeeklyTradingReportFilter
) => {
  return httpWebApi<Blob>({
    method: "GET",
    responseType: "blob",
    timeout: 60 * 4 * 1000,
    url: "reporting/getweeklytradingreport",
    params: {
      userid: user.userId,
      option: "D",
      year: filter.year,
      week: filter.yearPart,
    },
  });
};

export default getWeeklyDateReport;
